'use client';
"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TertiaryButton = exports.UnderlinedButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var LoadingSpinner_1 = require("../../components/loading-spinner/LoadingSpinner");
var visuallyHiddenStyles = __importStar(require("../../style/display/visually-hidden.module.scss"));
var styles = __importStar(require("./Button.module.scss"));
var Button = function (_a) {
    var _b, _c, _d;
    var _e = _a.tag, Tag = _e === void 0 ? 'button' : _e, children = _a.children, className = _a.className, _f = _a.type, type = _f === void 0 ? 'button' : _f, level = _a.level, size = _a.size, _g = _a.disabled, disabled = _g === void 0 ? false : _g, _h = _a.inverted, inverted = _h === void 0 ? false : _h, _j = _a.submitting, submitting = _j === void 0 ? false : _j, inline = _a.inline, sale = _a.sale, onClick = _a.onClick, onKeyDown = _a.onKeyDown, rest = __rest(_a, ["tag", "children", "className", "type", "level", "size", "disabled", "inverted", "submitting", "inline", "sale", "onClick", "onKeyDown"]);
    var classes = (0, classnames_1.default)(styles['c-button'], (_b = {},
        _b[styles["c-button--".concat(level)]] = !!level,
        _b[styles['c-button--inverted']] = inverted,
        _b[styles['c-button--disabled']] = disabled || submitting,
        _b[styles['c-button--submitting']] = submitting && level !== 'underlined',
        _b[styles['c-button--inline']] = inline,
        _b[styles['c-button--sale']] = sale,
        _b[styles["c-button--".concat(size)]] = !!size,
        _b), (_c = {},
        _c[styles[className]] = !!styles[className],
        _c), (_d = {},
        _d[className] = !styles[className] && !!className,
        _d));
    var hasDisabledButton = Tag === 'button' && (disabled || submitting);
    var handleDisabledEvent = function (event) {
        if (event.type === 'keydown' &&
            event.key !== 'Tab') {
            event.preventDefault();
        }
    };
    var spinnerSize = size === 'small' ? 'small' : 'medium';
    var ariaLabel = rest["aria-label"];
    return (react_1.default.createElement(Tag, __assign({}, rest, { "aria-disabled": hasDisabledButton, "aria-label": submitting ? 'Submitting' : ariaLabel, className: classes, onClick: hasDisabledButton ? handleDisabledEvent : onClick, onKeyDown: hasDisabledButton ? handleDisabledEvent : onKeyDown, type: Tag === 'button' ? type : undefined }), submitting && level !== 'underlined' ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, { size: spinnerSize }),
        react_1.default.createElement("span", { className: "hidden" }, children))) : (children)));
};
var PrimaryButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(Button, __assign({ level: "primary" }, rest, { "data-jlds": true }), children));
};
exports.PrimaryButton = PrimaryButton;
var SecondaryButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(Button, __assign({ level: "secondary" }, rest, { "data-jlds": true }), children));
};
exports.SecondaryButton = SecondaryButton;
var UnderlinedButton = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(Button, __assign({ level: "underlined" }, rest, { "data-jlds": true }), children));
};
exports.UnderlinedButton = UnderlinedButton;
var TertiaryButton = function (_a) {
    var _b;
    var children = _a.children, _c = _a.disabled, disabled = _c === void 0 ? false : _c, IconComponent = _a.IconComponent, iconPositionRight = _a.iconPositionRight, _d = _a.submitting, submitting = _d === void 0 ? false : _d, _e = _a.small, small = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? 'tonal-dark' : _f, className = _a.className, rest = __rest(_a, ["children", "disabled", "IconComponent", "iconPositionRight", "submitting", "small", "variant", "className"]);
    var classes = (0, classnames_1.default)((_b = {},
        _b[styles["c-button--tertiary-icon-right"]] = iconPositionRight,
        _b[styles["c-button--tertiary-icon"]] = !!IconComponent,
        _b[styles["c-button--tertiary-no-icon"]] = !IconComponent,
        _b[styles["c-button--tertiary-submitting"]] = submitting,
        _b), small
        ? styles['c-button--tertiary-small']
        : styles['c-button--tertiary-large'], styles["variant-".concat(variant)], className);
    var icon = function () {
        if (!IconComponent) {
            return null;
        }
        var preRenderedComponent = null;
        if (react_1.default.isValidElement(IconComponent)) {
            preRenderedComponent = IconComponent;
        }
        else if (typeof IconComponent === 'object') {
            var IconToRender = IconComponent;
            preRenderedComponent = react_1.default.createElement(IconToRender, { size: small ? 'medium' : 'large' });
        }
        return (react_1.default.createElement("span", { className: styles['icon-container'] },
            react_1.default.createElement("span", { className: (0, classnames_1.default)(styles.icon, submitting && visuallyHiddenStyles.visuallyHidden) }, preRenderedComponent)));
    };
    var ariaLabel = rest["aria-label"];
    return (react_1.default.createElement(Button, __assign({ "aria-label": submitting ? 'Submitting' : ariaLabel, className: classes, "data-jlds": true, disabled: disabled || submitting, level: "tertiary" }, rest),
        icon(),
        submitting ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, { inverted: variant === 'clear-white' || variant === 'filled-dark', size: "small" }),
            react_1.default.createElement("span", { className: styles['tertiary-content'] }, children))) : (react_1.default.createElement("span", { className: styles['tertiary-content'] }, children))));
};
exports.TertiaryButton = TertiaryButton;
//# sourceMappingURL=Button.js.map